import setProductListener from './SetProductListener'
import searchLoggedUserListener from './SearchLoggedUserListener'
import SearchCompanyListener from './SearchCompanyListener'
import SearchCompaniesListener from './SearchCompaniesListener'
import setTimezoneListener from './SetTimezoneListener'
import setMenuAvatarListener from './SetMenuAvatarListener'
import setLoadingMessageListener from './SetLoadingMessageListener'
import registerGlobalComponentsListener from './RegisterGlobalComponentsListener'
import interceptadorHttp from './InterceptadorHttp'

export default {
    searchLoggedUserListener,
    SearchCompanyListener,
    SearchCompaniesListener,
    setProductListener,
    setTimezoneListener,
    setMenuAvatarListener,
    setLoadingMessageListener,
    registerGlobalComponentsListener,
    interceptadorHttp
}
